/**
 * Service for fetching token prices from Odos API
 */
export class PriceService {
    constructor() {
        this.baseUrl = 'https://api.odos.xyz/pricing/token';
        this.defaultCurrency = 'USD';
        this.defaultChainId = 43114;
    }
    /**
     * Fetches the price of a token in the specified currency
     *
     * @param tokenAddress - The token contract address
     * @param chainId - The chain ID (e.g., 43114 for Avalanche)
     * @param currencyId - The currency to get the price in (defaults to USD)
     * @returns The token price information
     */
    async getTokenPrice(tokenAddress, chainId = this.defaultChainId, currencyId = this.defaultCurrency) {
        try {
            const response = await fetch(`${this.baseUrl}/${chainId}/${tokenAddress}?currencyId=${currencyId}`, {
                headers: {
                    accept: 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            return response.json();
        }
        catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            return {
                traceId: '',
                currencyId: currencyId,
                price: 0,
                error: `Failed to fetch token price: ${errorMessage}`,
            };
        }
    }
}
// Export a singleton instance for use throughout the application
export const priceService = new PriceService();
